var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94137 8.84666C2.94137 9.65611 2.28013 10.3173 1.47068 10.3173C0.661238 10.3173 0 9.65611 0 8.84666C0 8.03721 0.661238 7.37598 1.47068 7.37598H2.94137V8.84666Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68237 8.84666C3.68237 8.03721 4.34361 7.37598 5.15306 7.37598C5.9625 7.37598 6.62374 8.03721 6.62374 8.84666V12.5291C6.62374 13.3385 5.9625 13.9998 5.15306 13.9998C4.34361 13.9998 3.68237 13.3385 3.68237 12.5291V8.84666Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15306 2.94137C4.34361 2.94137 3.68237 2.28013 3.68237 1.47068C3.68237 0.661238 4.34361 0 5.15306 0C5.9625 0 6.62374 0.661238 6.62374 1.47068V2.94137H5.15306Z",
    fill: "#36C5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15309 3.68262C5.96254 3.68262 6.62378 4.34386 6.62378 5.1533C6.62378 5.96275 5.96254 6.62398 5.15309 6.62398H1.47068C0.661238 6.62398 0 5.96275 0 5.1533C0 4.34386 0.661238 3.68262 1.47068 3.68262H5.15309Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0586 5.1533C11.0586 4.34386 11.7198 3.68262 12.5293 3.68262C13.3387 3.68262 14 4.34386 14 5.1533C14 5.96275 13.3387 6.62398 12.5293 6.62398H11.0586V5.1533Z",
    fill: "#2EB67D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3176 5.15309C10.3176 5.96254 9.65635 6.62378 8.8469 6.62378C8.03746 6.62378 7.37622 5.96254 7.37622 5.15309V1.47068C7.37622 0.661238 8.03746 0 8.8469 0C9.65635 0 10.3176 0.661238 10.3176 1.47068V5.15309Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8469 11.0586C9.65635 11.0586 10.3176 11.7198 10.3176 12.5293C10.3176 13.3387 9.65635 14 8.8469 14C8.03746 14 7.37622 13.3387 7.37622 12.5293V11.0586H8.8469Z",
    fill: "#ECB22E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8469 10.3173C8.03746 10.3173 7.37622 9.65611 7.37622 8.84666C7.37622 8.03721 8.03746 7.37598 8.8469 7.37598H12.5293C13.3388 7.37598 14 8.03721 14 8.84666C14 9.65611 13.3388 10.3173 12.5293 10.3173H8.8469Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSlack);
export default __webpack_public_path__ + "static/media/ico_slack.3bae5a5501e065f45e90239f8fea57cc.svg";
export { ForwardRef as ReactComponent };